import Button from "common/components/Button/Button"
import { withFormik } from "formik"
import { InputNumber } from "primereact/inputnumber"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import * as Yup from "yup"
import { newDocumentoSelector } from "../redux/selectors/newDocumentoSelectors"
import { setShowDescuento } from "../redux/slices/newDocumentoSettingsSlice"
import { recalculate, setDescuento } from "../redux/slices/newDocumentoSlice"

const Descuento = ({
  handleSubmit,
  values,
  setFieldValue,
  onHide,
  isValid,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='descuento'>
            {t("crear.facturaRec.modal.discountLabel")} (%)
          </label>
          <InputNumber
            autoFocus
            id='descuento'
            name='descuento'
            min={1}
            useGrouping={false}
            value={values.descuento}
            onChange={(e) => setFieldValue("descuento", e.value)}
          />
        </div>
      </div>
      <div className='mt-4 col'>
        <div className='row justify-content-end align-items-center'>
          <a
            role='button'
            href='#'
            className='mr-3 link-cancel'
            onClick={onHide}
          >
            {t("crear.facturaRec.modal.cancelButton")}
          </a>
          <Button
            className='!tw-bg-primary'
            type='submit'
            disabled={!isValid}
          >
            {t("crear.facturaRec.modal.addButton")}
          </Button>
        </div>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  descuento: Yup.number().min(1).integer().required(),
})

const CreateWithFormik = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'descuento' does not exist on type '{}'.
  mapPropsToValues: ({ descuento }) => ({
    descuento: descuento || "",
  }),
  handleSubmit: ({ descuento }, { props }) => {
    // @ts-expect-error TS(2339): Property 'setDescuento' does not exist on type 'ob...
    props.setDescuento(descuento)
    // @ts-expect-error TS(2339): Property 'recalculate' does not exist on type 'obj...
    props.recalculate()
    // @ts-expect-error TS(2339): Property 'showDescuento' does not exist on type 'o...
    props.showDescuento(true)
    // @ts-expect-error TS(2339): Property 'onHide' does not exist on type 'object'.
    props.onHide()
  },
})(Descuento)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  setDescuento: (descuento: $TSMigrationFixMe) =>
    dispatch(setDescuento(descuento)),
  recalculate: () => dispatch(recalculate()),
  showDescuento: (show: $TSMigrationFixMe) => dispatch(setShowDescuento(show)),
})

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  descuento: newDocumentoSelector(state).descuento,
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateWithFormik)
